export const renderLabel = (val: string | number | boolean, filter: any) => {
  if (filter?.labelTransform) {
    return filter.labelTransform(val);
  }
  const label = filter?.label ?? "";
  return `${val} ${label}`;
};
